import React from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../incase-domain/components/modals/directory/Modal';
import Button from '../../../incase-domain/components/button/Button';

interface ConfirmModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

interface InsertSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    onViewPresentation: () => void;
}

export interface GeneratorModalsProps {
    newSession: ConfirmModalProps;
    revertPrompt: ConfirmModalProps;
    insertSuccess: InsertSuccessModalProps;
}

function GeneratorModals({newSession, revertPrompt, insertSuccess}: GeneratorModalsProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <>
            <Modal
                isOpen={newSession.isOpen}
                icon="solar:pen-new-square-outline"
                header={t('generator.newSessionHeader')}
                description={t('generator.newSessionDescription')}
                showCancel
                showConfirm
                onCancel={newSession.onClose}
                onConfirm={newSession.onConfirm}
            />

            <Modal
                isOpen={revertPrompt.isOpen}
                icon="solar:restart-circle-bold"
                header={t('generator.revertPromptHeader')}
                description={t('generator.revertPromptDescription')}
                showCancel
                showConfirm
                onCancel={revertPrompt.onClose}
                onConfirm={revertPrompt.onConfirm}
            />

            <Modal
                isOpen={insertSuccess.isOpen}
                icon="solar:check-circle-bold"
                header={t('generator.insertSuccessHeader')}
                description={t('generator.insertSuccessDescription')}
                showCancel
                onCancel={insertSuccess.onClose}
            >
                <Button variant="outline" onClick={insertSuccess.onViewPresentation}>
                    {t('generator.viewPresentation')}
                </Button>
            </Modal>
        </>
    );
}

export default GeneratorModals;
